import { ObjetMetier } from './objetMetier';
import { CrtDataLr } from './dataLr';
import { TemperatureExterieure } from './temperature-exterieure';
import { PhLight } from './lrRaw';

/**
 * Object Loi regulation CRT
 */
export interface Lr extends ObjetMetier {
  /**
   * Boolean pour dire si la loi est générique ou non
   */
  generique: boolean;
  /**
   * Données de la loi de régulation
   */
  datas: CrtDataLr[];
  /**
   * Echelle max sur l'axe X
   */
  echelleMaxX: number;
  /**
   * Echelle max sur l'axe Y
   */
  echelleMaxY: number;
  /**
   * Echelle min sur l'axe X
   */
  echelleMinX: number;
  /**
   * Echelle min sur l'axe Y
   */
  echelleMinY: number;
  /**
   * pas l'axe X
   */
  pasX: number;
  /**
   * pas l'axe X
   */
  pasY: number;
  /**
   * Type d'extrapolation
   */
  typeExtrapolation: TypeExtrapolation;
  /**
   * Type de courbe
   */
  typeCourbe: TypeCourbe;
  /**
   * Description axe X
   */
  descriptionAxeX: string;
  /**
   * Description axe Y
   */
  descriptionAxeY: string;
  /**
   * Temperature Exterieure
   */
  tempExt: TemperatureExterieure;
  /**
   * Programmes horaires associés à la Lr
   */
  programmesHoraires: PhLight[];
  /**
   * Statut de l'écart avec les valeurs conseillées
   */
  ecartStatus: EcartStatus;
  /**
   * TypeLR
   */
  typeLR: TypeLR;
  /**
   * Nom image
   */
  image: string;
  /*
   * Flag Copilot Ready
   */
  copilotReady: boolean;
  /**
   * Transmetteur
   */
  transmetteur: string;
  /**
   * Id SDD
   */
  idSdd: number;
}

export enum TypeExtrapolation {
  PROLONGATION = 'PROLONGATION',
  LIMITATION = 'LIMITATION',
}

export enum TypeLR {
  LOI_GENERIQUE_CONSIGNE = 'LOI_GENERIQUE_CONSIGNE',
  LOI_GENERIQUE_COURBE = 'LOI_GENERIQUE_COURBE',
}

export enum TypeCourbe {
  MONOTONE_CROISSANTE = 'MONOTONE_CROISSANTE',
  MONOTONE_DECROISSANTE = 'MONOTONE_DECROISSANTE',
  MONOTONE_STRICTE_CROISSANTE = 'MONOTONE_STRICTE_CROISSANTE',
  MONOTONE_STRICTE_DECROISSANTE = 'MONOTONE_STRICTE_DECROISSANTE',
  Y_LIBRE = 'Y_LIBRE',
}

export enum EcartStatus {
  Invisible = 'Invisible',
  Gris = 'Gris',
  Orange = 'Orange',
  Vert = 'Vert',
}
